import * as React from "react";
import * as OAuth from "oauth2";
import * as Messenger from "../messenger";

// Composant à appeler pour mettre à jour les dépendances du service worker (token, etc.)
const serviceWorkerUpdater = () => {
  const { token, user } = OAuth.useAuth();

  // Si le service worker vient à se complexifier, penser à potentiellement mettre en pause les fetchs le temps que
  // les dépendances du service worker soient mises à jour pour ensuite les reprendre.
  const update = React.useCallback(() => {
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker.ready.then(() => {
      sendAuth(token, user);
    });
  }, [navigator, token, user]);

  React.useEffect(() => {
    update();

    navigator.serviceWorker.addEventListener("controllerchange", () =>
      update(),
    );

    return () => {
      navigator.serviceWorker.removeEventListener("controllerchange", () =>
        update(),
      );
    };
  }, [update]);

  return null;
};

export const sendAuth = (token, user) =>
  Messenger.sendMessage({
    type: "SET_AUTH",
    token,
    user,
  });

export default serviceWorkerUpdater;
